package com.hyperether.goodjob.scenes.contacts

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredHeight
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Divider
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.em
import androidx.navigation.NavHostController
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.itemDetailsMargin
import com.hyperether.goodjob.itemDetailsMenuMargin
import com.hyperether.goodjob.map.MapComponent
import com.hyperether.goodjob.navigation.AddNewContact
import com.hyperether.goodjob.navigation.AddNewJob
import com.hyperether.goodjob.navigation.AddNewSite
import com.hyperether.goodjob.navigation.Contacts
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.about_this_contact
import com.hyperether.goodjob.resources.add_job
import com.hyperether.goodjob.resources.add_site
import com.hyperether.goodjob.resources.address
import com.hyperether.goodjob.resources.briefcase_unselect
import com.hyperether.goodjob.resources.building
import com.hyperether.goodjob.resources.city
import com.hyperether.goodjob.resources.contact_deteils
import com.hyperether.goodjob.resources.contact_information
import com.hyperether.goodjob.resources.contact_name
import com.hyperether.goodjob.resources.contact_person
import com.hyperether.goodjob.resources.contact_type
import com.hyperether.goodjob.resources.country
import com.hyperether.goodjob.resources.edit
import com.hyperether.goodjob.resources.email_capital
import com.hyperether.goodjob.resources.email_send_icon
import com.hyperether.goodjob.resources.employee
import com.hyperether.goodjob.resources.handshake_thin_svgrepo_com_1
import com.hyperether.goodjob.resources.ic_map_pin
import com.hyperether.goodjob.resources.ic_user
import com.hyperether.goodjob.resources.industry
import com.hyperether.goodjob.resources.jobs
import com.hyperether.goodjob.resources.location
import com.hyperether.goodjob.resources.mail
import com.hyperether.goodjob.resources.phone
import com.hyperether.goodjob.resources.phone_24
import com.hyperether.goodjob.resources.site
import com.hyperether.goodjob.resources.site_contact_person
import com.hyperether.goodjob.resources.sites
import com.hyperether.goodjob.resources.status
import com.hyperether.goodjob.resources.time
import com.hyperether.goodjob.resources.title
import com.hyperether.goodjob.resources.world_2_svgrepo_com_1
import com.hyperether.goodjob.resources.zip
import com.hyperether.goodjob.scenes.components.DetailsContainerContact
import com.hyperether.goodjob.scenes.components.DetailsDivider
import com.hyperether.goodjob.scenes.components.DetailsLeftMenuItem
import com.hyperether.goodjob.scenes.components.WebSearchField
import com.hyperether.goodjob.scenes.components.WebViewHeader
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.contacts.components.JobListGroupedByDate
import com.hyperether.goodjob.scenes.contacts.components.SiteListWeb
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.theme.DashboardBg
import com.hyperether.goodjob.theme.EmployeeDetailsText
import com.hyperether.goodjob.util.Constants.DEFAULT_SITE_ID
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.goodjob.webDetailsTitle
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun ContactDetailsWeb(
    navHostController: NavHostController, viewModel: ContactsViewModel, contactId: String
) {
    var selectedIndex by remember { mutableStateOf(0) }
    val searchQuery = remember { mutableStateOf("") }
    val contact by viewModel.contact.collectAsState()
    var columnHeight by remember { mutableStateOf(0.dp) }
    val density = LocalDensity.current

    LaunchedEffect(contactId) {
        viewModel.init()
        viewModel.fetchContactById(contactId)
    }
    LaunchedEffect(contact) {
        viewModel.getSitesForContactRemote(contactId)
    }

    val scrollState = rememberScrollState()
    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(DashboardBg)
            .verticalScrollbar(scrollState)
            .verticalScroll(scrollState)
            .disableMouseDragScrollOnWeb()
    ) {
        WebViewHeader(
            isAddNewJob = false,
            isBackAvailable = true,
            onBackClick = { navHostController.navigate(Contacts) },
            isAddNewContact = true,
            title = contact?.name ?: "",
            isImportAndAddVisible = !viewModel.isEmployee(),
            navHostController = navHostController
        )

        DetailsContainerContact {
            Column(modifier = Modifier.weight(1f)) {
                Column(
                    modifier = Modifier
                        .width(210.toScaleDp())
                        .fillMaxHeight()
                        .padding(top = itemDetailsMenuMargin())
                ) {
                    DetailsLeftMenuItem(
                        stringResource(Res.string.contact_deteils),
                        selectedIndex == 0,
                        onSelected = { selectedIndex = 0 }
                    )
                    DetailsLeftMenuItem(
                        stringResource(Res.string.sites),
                        selectedIndex == 2,
                        onSelected = { selectedIndex = 2 }
                    )
                    DetailsLeftMenuItem(
                        stringResource(Res.string.jobs),
                        selectedIndex == 3,
                        onSelected = { selectedIndex = 3 }
                    )
                }
            }
            DetailsDivider()
            Column(modifier = Modifier.fillMaxWidth().weight(5f)) {
                //TAB DETAILS
                if (selectedIndex == 0) {
                    Row(
                        verticalAlignment = Alignment.Top,
                        modifier = Modifier
                            .height(webDetailsTitle())
                            .padding(itemDetailsMargin())
                    ) {
                        Text(
                            modifier = Modifier.weight(1f),
                            text = stringResource(Res.string.about_this_contact),
                            fontSize = 27.toScaleSp(),
                            fontWeight = FontWeight.W700,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )

                        Spacer(modifier = Modifier.weight(1f))
                        if (!viewModel.isEmployee()) {
                            Row(
                                modifier = Modifier.clickableWithPointer {
                                    navHostController.navigate(AddNewContact(contact?.id ?: ""))
                                },
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Image(
                                    painter = painterResource(Res.drawable.edit),
                                    contentDescription = "",
                                    modifier = Modifier.padding(
                                        end = 16.toScaleDp()
                                    ).size(20.toScaleDp())
                                )
                                DisableSelection {
                                    Text(
                                        text = stringResource(Res.string.edit),
                                        fontSize = 18.toScaleSp(),
                                        fontWeight = FontWeight.Normal,
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                }
                            }
                        }
                    }
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(
                                end = itemDetailsMargin(),
                                bottom = itemDetailsMargin()
                            )
                    ) {
                        // ContactDetailsRow has 20dp size and 12 dp padding, so map has to be
                        Column(
                            modifier = Modifier
                                .fillMaxWidth().weight(1.5f)
                                .padding(
                                    start = itemDetailsMargin() - 12.toScaleDp(),
                                    end = itemDetailsMargin() - 12.toScaleDp()
                                )
                                .onSizeChanged { size ->
                                    columnHeight = with(density) { size.height.toDp() }
                                }
                        ) {
                            ContactDetailsRow(
                                Res.drawable.handshake_thin_svgrepo_com_1,
                                stringResource(Res.string.contact_type),
                                viewModel.contactTypeMap.entries.find { item -> item.value == contact?.contactType }?.key
                                    ?: ""
                            )
                            ContactDetailsRow(
                                Res.drawable.ic_user,
                                stringResource(Res.string.contact_name),
                                contact?.name ?: ""
                            )
                            ContactDetailsRow(
                                Res.drawable.email_send_icon,
                                stringResource(Res.string.email_capital),
                                contact?.email ?: ""
                            )
                            ContactDetailsRow(
                                Res.drawable.phone_24,
                                stringResource(Res.string.phone),
                                contact?.phone ?: ""
                            )
                            ContactDetailsRow(
                                Res.drawable.building,
                                stringResource(Res.string.city),
                                contact?.addressObject?.city ?: ""
                            )
                            ContactDetailsRow(
                                Res.drawable.world_2_svgrepo_com_1,
                                stringResource(Res.string.country),
                                contact?.addressObject?.country ?: ""
                            )
                            ContactDetailsRow(
                                Res.drawable.mail,
                                stringResource(Res.string.zip),
                                contact?.addressObject?.zip ?: ""
                            )
                            ContactDetailsRow(
                                Res.drawable.ic_map_pin,
                                stringResource(Res.string.address),
                                contact?.addressObject?.address ?: "",
                                detailsTextColor = BlueApp
                            )
                            ContactDetailsRow(
                                Res.drawable.briefcase_unselect,
                                stringResource(Res.string.industry),
                                contact?.industry ?: ""
                            )
                            Spacer(modifier = Modifier.height(10.toScaleDp()))
                            Divider(
                                modifier = Modifier.height(1.toScaleDp())
                                    .background(Color.LightGray.copy(alpha = 0.1f))
                                    .padding(
                                        start = 15.toScaleDp(),
                                        end = 15.toScaleDp()
                                    )
                            )
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            Text(
                                modifier = Modifier.weight(2f)
                                    .padding(
                                        start = 15.toScaleDp(),
                                        top = 23.toScaleDp()
                                    ),
                                text = stringResource(Res.string.contact_person),
                                fontSize = 20.toScaleSp(),
                                fontWeight = FontWeight.W700,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                            ContactDetailsRow(
                                Res.drawable.ic_user,
                                stringResource(Res.string.contact_person),
                                contact?.personName ?: ""
                            )
                            ContactDetailsRow(
                                Res.drawable.email_send_icon,
                                stringResource(Res.string.email_capital),
                                contact?.personEmail ?: ""
                            )
                            ContactDetailsRow(
                                Res.drawable.phone_24,
                                stringResource(Res.string.phone),
                                contact?.personPhone ?: ""
                            )
                        }
                        Box(
                            modifier = Modifier.weight(1f)
                                .height(columnHeight - 24.toScaleDp()) // 12 padding top and bottom
                                .background(
                                    Color.LightGray,
                                    shape = RoundedCornerShape(8.toScaleDp())
                                ).border(
                                    width = 1.toScaleDp(),
                                    shape = RoundedCornerShape(8.toScaleDp()),
                                    color = BorderColor
                                ).padding()
                        ) {
                            MapComponent(
                                showMapWeb = mutableStateOf(true),
                                showMap = true,
                                markers = viewModel.getSiteOrContactMarkers(),
                                currentPosition = mutableStateOf(viewModel.getSiteOrContactCurrentPosition())
                            )
                        }
                    }
                }

                //TAB SITES
                if (selectedIndex == 2) {
                    Row(
                        verticalAlignment = Alignment.Top,
                        modifier = Modifier.height(webDetailsTitle()).padding(itemDetailsMargin())
                    ) {
                        Text(
                            modifier = Modifier.weight(1f),
                            text = stringResource(Res.string.sites),
                            fontSize = 24.toScaleSp(),
                            fontWeight = FontWeight.W700,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )

                        Spacer(modifier = Modifier.weight(1f))
                        if (!viewModel.isEmployee()) {
                            Row(
                                horizontalArrangement = Arrangement.End,
                                verticalAlignment = Alignment.CenterVertically,
                                modifier = Modifier.background(
                                    color = BlueApp,
                                    shape = RoundedCornerShape(32.toScaleDp())
                                ).padding(
                                    horizontal = 12.toScaleDp(),
                                    vertical = 10.toScaleDp()
                                )
                            ) {
                                DisableSelection {
                                    Text(
                                        text = stringResource(Res.string.add_site),
                                        color = Color.White,
                                        fontSize = 14.toScaleSp(),
                                        fontWeight = FontWeight.W400,
                                        modifier = Modifier.clickableWithPointer {
                                            if (getPlatformChecker().isMobile()) {
                                                navHostController.navigate(
                                                    AddNewSite(
                                                        contactId,
                                                        DEFAULT_SITE_ID
                                                    )
                                                )
                                            } else {
                                                navHostController.navigate(
                                                    AddNewSite(
                                                        contactId,
                                                        ""
                                                    )
                                                )
                                            }
                                        },
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                }
                            }
                        }

//                                    DropdownSortBy(
//                                        shouldAppendSortBy = false,
//                                        items = listOf("Newest"),
//                                        selectedValue = "Newest",
//                                        onValueSelected = { },
//                                        displayText = { "Sort by: $it" },
//                                        placeholderColor = BorderColor,
//                                        textColor = Color.Black,
//                                        modifier = Modifier.height(Dp(45f)).padding(start = Dp(10f))
//                                    )
                    }
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .padding(horizontal = 45.toScaleDp())
                            .requiredHeight(height = 38.toScaleDp()),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.Start,
                            modifier = Modifier.weight(1.4f)
                        ) {
//                                        Checkbox(checked = false, onCheckedChange = { })

                            Text(
                                text = stringResource(Res.string.site_contact_person),
                                lineHeight = 1.5.em,
                                fontWeight = FontWeight.W700,
                                style = TextStyle(fontSize = 14.toScaleSp()),
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                        Text(
                            text = stringResource(Res.string.address),
                            lineHeight = 1.5.em,
                            fontWeight = FontWeight.W700,
                            style = TextStyle(
                                fontSize = 14.toScaleSp()
                            ),
                            modifier = Modifier.weight(1.5f),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Text(
                            text = stringResource(Res.string.contact_information),
                            lineHeight = 1.5.em,
                            fontWeight = FontWeight.W700,
                            style = TextStyle(
                                fontSize = 14.toScaleSp()
                            ),
                            modifier = Modifier.weight(1.5f),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                    Divider(
                        modifier = Modifier.height(1.toScaleDp())
                            .background(Color.LightGray.copy(alpha = 0.1f))
                            .padding(start = 15.toScaleDp(), end = 15.toScaleDp())
                    )
                    DisableSelection {
                        SiteListWeb(
                            viewModel.currentSitesForContact,
                            navHostController,
                            viewModel.isEmployee(),
                            onEditSiteClick = { siteId ->
                                siteId?.let {
                                    navHostController.navigate(AddNewSite(contactId, it))
                                }
                            })
                    }
                }
                //TAB JOBS
                if (selectedIndex == 3) {
                    Row(
                        verticalAlignment = Alignment.Top,
                        modifier = Modifier.height(webDetailsTitle()).padding(itemDetailsMargin())
                    ) {
                        Text(
                            modifier = Modifier.weight(1f),
                            text = stringResource(Res.string.jobs),
                            fontSize = 24.toScaleSp(),
                            fontWeight = FontWeight.W700,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Spacer(modifier = Modifier.weight(1f))
                        Row(
                            horizontalArrangement = Arrangement.End,
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier.background(
                                color = BlueApp,
                                shape = RoundedCornerShape(32.toScaleDp())
                            ).padding(
                                horizontal = 12.toScaleDp(),
                                vertical = 10.toScaleDp()
                            )
                        ) {
                            DisableSelection {
                                Text(
                                    text = stringResource(Res.string.add_job),
                                    color = Color.White,
                                    fontSize = 14.toScaleSp(),
                                    fontWeight = FontWeight.W400,
                                    modifier = Modifier.clickableWithPointer {
                                        navHostController.navigate(AddNewJob(""))
                                    },
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                            }
                        }
                        Spacer(modifier = Modifier.width(16.toScaleDp()))

                        WebSearchField(
                            text = searchQuery.value,
                            onTextChange = {
                                searchQuery.value = it
                            }
                        )
                    }
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .background(color = Color(0xfffafafa))
                            .padding(horizontal = 45.toScaleDp())
                            .requiredHeight(height = 38.toScaleDp()),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Text(
                            text = stringResource(Res.string.title),
                            fontWeight = FontWeight.W700,
                            lineHeight = 1.5.em,
                            style = TextStyle(
                                fontSize = 14.toScaleSp()
                            ),
                            modifier = Modifier.weight(0.9f)
                        )
                        Text(
                            text = stringResource(Res.string.site),
                            fontWeight = FontWeight.W700,
                            lineHeight = 1.5.em,
                            style = TextStyle(
                                fontSize = 14.toScaleSp()
                            ),
                            modifier = Modifier.weight(0.9f),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Text(
                            text = stringResource(Res.string.location),
                            fontWeight = FontWeight.W700,
                            lineHeight = 1.5.em,
                            style = TextStyle(
                                fontSize = 14.toScaleSp()
                            ),
                            modifier = Modifier.weight(1f),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Text(
                            text = stringResource(Res.string.time),
                            fontWeight = FontWeight.W700,
                            lineHeight = 1.5.em,
                            style = TextStyle(
                                fontSize = 14.toScaleSp()
                            ),
                            modifier = Modifier.weight(0.7f),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Text(
                            text = stringResource(Res.string.employee),
                            fontWeight = FontWeight.W700,
                            lineHeight = 1.5.em,
                            style = TextStyle(
                                fontSize = 14.toScaleSp()
                            ),
                            modifier = Modifier.weight(0.7f),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Text(
                            text = stringResource(Res.string.status),
                            fontWeight = FontWeight.W700,
                            textAlign = TextAlign.Center,
                            lineHeight = 1.5.em,
                            style = TextStyle(
                                fontSize = 14.toScaleSp()
                            ),
                            modifier = Modifier.weight(0.5f),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                    val filteredJobs =
                        viewModel.jobList.filter { it.contactParentId == contactId }
                    val searchJobs =
                        viewModel.searchJobs(searchQuery.value, filteredJobs)
                    JobListGroupedByDate(
                        sites = viewModel.sitesMap,
                        jobs = viewModel.sortJobs(searchJobs),
                        navHostController = navHostController,
                        location = contact?.addressObject?.address ?: ""
                    )
                }
            }
        }
    }
}

@Composable
fun ContactDetailsRow(
    painterResource: DrawableResource,
    labelText: String,
    detailsText: String,
    modifier: Modifier = Modifier,
    detailsTextColor: Color = Color.Black,
    textColor: Color = EmployeeDetailsText,
) {
    Row(
        modifier = modifier
            .padding(12.toScaleDp()),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.weight(1f)
        ) {
            Image(
                painter = painterResource(painterResource),
                contentDescription = null,
                modifier = Modifier.size(20.toScaleDp())
            )
            Text(
                text = labelText,
                color = textColor,
                fontSize = 14.toScaleSp(),
                modifier = Modifier.padding(start = 20.toScaleDp()),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
        Text(
            text = detailsText,
            color = detailsTextColor,
            fontWeight = FontWeight.Bold,
            fontSize = 14.toScaleSp(),
            modifier = Modifier.padding(start = 20.toScaleDp()),
            maxLines = 2,
            overflow = TextOverflow.Ellipsis
        )
    }
}
